import { useSelector } from "react-redux";
import { TutorSettings } from "./tutorSettings";
import { UserSettings } from "./userSettings";
import { Link } from "react-router-dom";
import { ProfileRole } from "../../store/profile/profileSlice";

const Settings = () => {
    const { currentProfile } = useSelector((state) => state.profile);
    const role = currentProfile?.role;
    return (
        <>
            {(role === ProfileRole.STUDENT  || role === ProfileRole.GUEST)&& <div>
                <UserSettings />
            </div>}

            {(role === ProfileRole.TUTOR) && <div>
                {/* <div className="flex justify-between items-center">
                    <Link to={"/me"} target="_blank"  className="bg-nt-blue text-white rounded py-2 mt-1 no-underline px-3">Profile Preview</Link>
                </div> */}
                <TutorSettings />
            </div>}
            
        </>
    )
}

export {Settings};